import React, { useEffect, useState } from 'react';
import { fetchElevation } from '../services/elevationService';
import MapLogo from './MapLogo';
import AddressInfo from './AddressInfo';
import ElevationInfo from './ElevationInfo';
import WeatherInfo from './WeatherInfo';
import NearestStations from './NearestStations';
import MobileActions from './MobileActions';

/**
 * 地図の位置情報（画面下部）コンポーネント
 */
const LocationInfo = ({
  locationInfo,
  onLocationUpdate,
  weather,
  openLongPressAtMapCenter,
  isSearchResultOpen,
  isSearchResultVisible,
  setIsSearchResultVisible,
  isTablet
}) => {

  const address = locationInfo?.address || '';
  const stations = locationInfo?.stations || [];
  const center = locationInfo?.center || null;

  // 標高情報の状態管理
  const [elevation, setElevation] = useState(null);

  // 座標が変わったら標高情報を取得
  useEffect(() => {
    if (center?.lat && center?.lng) {
      fetchElevation(center.lat, center.lng)
        .then(data => {
          setElevation(data);
          // 親コンポーネントに通知
          if (onLocationUpdate) {
            onLocationUpdate({ elevation: data });
          }
        })
        .catch(() => {
          setElevation(null);
        });
    }
  }, [center, onLocationUpdate]);

  // モバイル端末で非表示にする項目についてはlocation-info.cssで指定(max-width: 600px）
  return (
    <>
      <MapLogo />
      <div className="address-group">
        <div className="address-info">
          <AddressInfo address={address} />
          <ElevationInfo elevation={elevation} />
          <WeatherInfo weather={weather} />
        </div>

        {isTablet && (
          <MobileActions
            isSearchResultOpen={isSearchResultOpen}
            isSearchResultVisible={isSearchResultVisible}
            setIsSearchResultVisible={setIsSearchResultVisible}
            openLongPressAtMapCenter={openLongPressAtMapCenter}
          />
        )}
      </div>
      <NearestStations stations={stations} />
    </>
  );
};

export default LocationInfo;